import Icon from './Icon.vue';

export default Icon;



// WEBPACK FOOTER //
// ./src/pages/profile/components/icon/index.ts